
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Vant from 'vant';
import 'vant/lib/index.css';
import './assets/scss/common.scss';
import './assets/scss/reset.css';
import common from '@/assets/ts/common';

//挂载调试器
// import Vacuole from 'vconsole';
// let vConsole:any = new Vacuole();

const app = createApp(App);

//引入全局公共组件
import cHeader  from '@/components/cHeader.vue';
import serviceBtn from '@/components/serviceBtn.vue';
import dialog from "@/components/dialog.vue";
app.component("cHeader",cHeader);
app.component("serviceBtn",serviceBtn);
app.component("cModal",dialog);
app.config.globalProperties.$common = common;
app.use(store).use(router).use(Vant).mount('#app');
// use(vConsole).
